import React, { Component } from "react";
import { Jumbotron, Row, Col, Container, NavLink, Button, Card, CardBody } from "reactstrap";
import Notifications from "./Notifications";
import MachineList from "../machines/MachineList";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Landing from "../layout/Landing";
import AddMachine from "../machines/AddMachine";
import SearchMachine from "../machines/SearchMachine";
import AddUser from "../users/AddUser";
import { Link, Redirect } from "react-router-dom";
import ViewAllMachines from "../machines/ViewAllMachines";




class Dashboard extends Component {
  render() {
    const machines = this.props.machines;
    const auth = this.props.auth;

    return (
      <div>
        {auth && auth.uid ? (
          auth.email === "admin@boooyamachinery.lk" ? (
            <Jumbotron className="bg-white">
              <Container fluid>
                <Row>
                  <Col md="4" className="mt-3">
                    <h4>Add New Machine</h4>
                    <AddMachine />
                    {/* <MachineList machines={machines} /> */}
                  </Col>
                  <Col md="4" className="mt-3">
                    <h4>Update Machine</h4>
                    <SearchMachine />
                  </Col>
                  <Col md="4" className="mt-3">
                    <h4>System Management</h4>
                    {/* <Notifications /> */}
                    <Card>
                      <CardBody>
                        <Button color="primary" size="md" block className="mb-3">
                          <NavLink tag={Link} to="/allmachines" className="text-white">
                            All Machines
                      </NavLink>
                        </Button>
                        <AddUser />
                      </CardBody>

                    </Card>

                  </Col>
                </Row>
              </Container>
            </Jumbotron>
          ) : 

          (auth.email === "viewer@boooyamachinery.lk" ? 
          (
            <Redirect to="/allmachines" />
          ):(
            <Jumbotron className="bg-white">
            <Container fluid>
              <Row>
                <Col md="2"></Col>
                <Col md="4" className="mt-3">
                  <h4>Find and Update Machine</h4>
                  <SearchMachine userType={"unit"} />
                </Col>
                <Col md="4" className="mt-3">
                  <h4>All Machines in the Unit</h4>
                  <Card>
                    <CardBody>
                      <Button color="primary" size="md" block className="mb-3">
                        <NavLink tag={Link} to="/allmachines" className="text-white">
                          All Machines
                         </NavLink>
                      </Button>
                    </CardBody>
                  </Card>

                </Col>
                <Col md="2"></Col>
              </Row>
            </Container>
          </Jumbotron>
          ))

        ) : (
            <Landing />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    machines: state.firestore.ordered.machines,
    auth: state.firebase.auth,

  };
};

export default compose(
  connect(mapStateToProps)
)(Dashboard);
